import {DELETE_CDC_CARD_ERROR, DELETE_CDC_CARD_START, DELETE_CDC_CARD_SUCCESS} from "../../types";

export default function delete_card_category(state, action) {
    switch (action.type) {
        case DELETE_CDC_CARD_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case DELETE_CDC_CARD_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case DELETE_CDC_CARD_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
